import React, { Component } from 'react';
import SummarySectionComponent from './SummarySectionComponent';
import authProvider from '../../authProvider';

const REQUESTS_COLOR = 'yellow';
const IMPRESSIONS_COLOR = '#009fdb';
const CPM_COLOR = '#f02d5b';
const REVENUE_COLOR = '#49b27b';

const isAdmin = (role) => ['admin', 'report_admin', 'advertiser'].includes(role);
let globalRole = 'publisher';

export default class SummaryComponent extends Component {
    constructor(props) {
      super(props);
      authProvider.getPermissions().then(({role}) => {
        globalRole = role;
      })
    }
  
    render() {
      const { loading, totalRevenue, totalImpressions, totalAdRequests, totalGrossImpressions, averageCPM, slopeRevenue, 
        slopeImpressions, slopeAdRequests, slopeCPM, interceptRevenue, interceptImpressions, interceptAdRequests, 
        interceptCPM, minRevenue, minImpressions, minAdRequests, minCPM, maxRevenue, maxImpressions, maxAdRequests, 
        maxCPM, imps, adreqs, revs, cpms } = this.props;
      return (
  
        <div style={{ display: 'flex', justifyContent: 'space-between', gap: '16px', width: '100%', overflow: 'hidden', paddingBottom: '10px', align: 'center' }} >
  
        <SummarySectionComponent
          title='IMPRESSIONS'
          tooltip='impressions'
          color={IMPRESSIONS_COLOR}
          value={(totalImpressions) ? new Intl.NumberFormat('en-US').format(totalImpressions) : "-"}
          min={(minImpressions) ? new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(minImpressions) : "-"}
          max={(maxImpressions) ? new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(maxImpressions) : "-"}
          slope={(slopeImpressions) ? new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(slopeImpressions) : "-"}
          intercept={(interceptImpressions) ? new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(interceptImpressions) : "-"}
          graphValues={imps}
          loading={loading}
        />
  
        <SummarySectionComponent
          title={isAdmin(globalRole) ? 'GROSS REVENUE' : 'REVENUE'}
          tooltip='revenue'
          color={REVENUE_COLOR}
          value={(totalRevenue) ? new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumSignificantDigits: 8 }).format(totalRevenue) : "-"}
          min={(minRevenue) ? new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 2 }).format(minRevenue) : "-"}
          max={(maxRevenue) ? new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 2 }).format(maxRevenue) : "-"}
          slope={(slopeRevenue) ? new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(slopeRevenue) : "-"}
          intercept={(interceptRevenue) ? new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(interceptRevenue) : "-"}
          graphValues={revs}
          labelPreFix='$'
          loading={loading}
        />
  
        <SummarySectionComponent
          title='AVERAGE CPM'
          tooltip='average CPM'
          color={CPM_COLOR}
          value={(averageCPM) ? new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumSignificantDigits: 5 }).format(averageCPM) : "-"}
          min={(minCPM) ? new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 2 }).format(minCPM) : "-"}
          max={(maxCPM) ? new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 2 }).format(maxCPM) : "-"}
          slope={(slopeCPM) ? new Intl.NumberFormat('en-US', { maximumFractionDigits: 8 }).format(slopeCPM) : "-"}
          intercept={(interceptCPM) ? new Intl.NumberFormat('en-US', { maximumFractionDigits: 8 }).format(interceptCPM) : "-"}
          graphValues={cpms}
          labelPreFix='$'
          loading={loading}
        />
  
        </div>
      )
    }
  }